window.$ = window.jQuery = require('jquery');

import('../../vendor/integration/src/js/main');

import '@ungap/custom-elements';

import 'jquery-ui';

import Chart from 'chart.js/auto';

import swal from 'sweetalert2';
window.swal = swal;

require('@popperjs/core');

require('sparkline');

window.toastr = require('toastr');

require('hegyd/core/resources/assets/js/hegyd-core.js');
require('hegyd/core/resources/assets/js/main.js');
require('hegyd/core/resources/assets/dependencies/jquery-form/jquery.form.js');

import AddToCart from './carts/add-to-cart';
customElements.define('add-to-cart', AddToCart,{extends: 'div'});

import AddToCartFeatured from './carts/add-to-cart-featured';
customElements.define('add-to-cart-featured', AddToCartFeatured,{extends: 'div'});

import CreateNewCart from './carts/create-new-cart';
customElements.define('create-new-cart', CreateNewCart,{extends: 'div'});

import ImportCart from './carts/import-cart';
customElements.define('import-cart', ImportCart,{extends: 'div'});

import CartItem from './carts/cart-item';
customElements.define('cart-item', CartItem,{extends: 'div'});

import CartLineItem from './carts/cart-line-item';
customElements.define('cart-line-item', CartLineItem,{extends: 'div'});

import CartsList from './carts/carts-list';
customElements.define('carts-list', CartsList,{extends: 'div'});

import CartDelivery from './carts/cart-delivery';
customElements.define('cart-delivery', CartDelivery,{extends: 'div'});

import Search from './search/Search';
customElements.define('search-form', Search,{extends: 'form'});

import InactiveFilter from './search/InactiveFilter';
customElements.define('inactive-filter', InactiveFilter,{extends: 'div'});

import SearchCart from './search/SearchCart.js';
customElements.define('search-cart', SearchCart,{extends: 'input'});

import quickAdd from './search/QuickCart.js';
customElements.define('quick-cart', quickAdd,{extends: 'button'});

import AjaxSearch from './search/AjaxSearch.js';
customElements.define('ajax-search', AjaxSearch,{extends: 'input'});

import AddToOrder from './carts/add-to-order';
customElements.define('add-to-order', AddToOrder,{extends: 'select'});

import ModalAnotherDocuments from './modals/modalAnotherDocuments';
customElements.define('modal-another-documents', ModalAnotherDocuments,{extends: 'div'});

import DonutChart from './charts/donut';
customElements.define('donut-chart', DonutChart,{extends: 'canvas'});

import BarChart from './charts/bar';
customElements.define('bar-chart', BarChart,{extends: 'canvas'});

import DashboardSelect from './dashboard/DashboardSelect';
customElements.define('dashboard-select', DashboardSelect,{extends: 'div'});

import DashboardSalesman from './dashboard/DashboardSalesman';
customElements.define('dashboard-salesman', DashboardSalesman,{extends: 'div'});

import MobileNav from './mobile/MobileNav';
customElements.define('mobile-nav', MobileNav,{extends: 'div'});


require('hegyd/products/resources/assets/js/main-fo.js');
require('hegyd/core/resources/assets/js/components/Form/main');
require('hegyd/sav/resources/assets/js/main-fo.js');
require('hegyd/modal-information/resources/assets/js/extranet/main.js');